<div><slot /></div>

<style>
  div {
    display: flex;
    border-bottom: 1px solid var(--theme-border);
    margin-bottom: 5px;
  }
</style>
